import React, { useEffect, useState } from "react";
import AOS from "aos";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";


function AddWorkshop({ setShowForm, selectedWorkshop, refreshManagers }) {
    const [newWorkshop, setNewWorkshop] = useState({
        date: new Date().toISOString().split("T")[0],
        workshop_name: "",
        address: "",
        latitude: "",
        longitude: "",
        email: "",
        password: "",
        ownerName: "",
        ownerPhone: "",
        name: "",
        contactPhone: "",
        status: "Active",
        area:"",
        pincode:""
    });

    const isEditing = !!selectedWorkshop;


    useEffect(() => {
        if (selectedWorkshop) {
            setNewWorkshop({
                id: selectedWorkshop.id || '',
                workshop_name: selectedWorkshop.workshop || "",
                address: selectedWorkshop.address || "",
                latitude: selectedWorkshop.latitude || "",
                longitude: selectedWorkshop.longitude || "",
                email: selectedWorkshop.email || "",
                password: selectedWorkshop.password || "",
                ownerName: selectedWorkshop.owner_name || "",
                ownerPhone: selectedWorkshop.owner_phone || "",
                name: selectedWorkshop.name || "",
                contactPhone: selectedWorkshop.phone || "",
                pincode: selectedWorkshop.pincode || "",
                area: selectedWorkshop.area || "",
                status: "Active",
            });
           
        }
    }, [selectedWorkshop]);

    console.log('selected workshop', selectedWorkshop)

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setNewWorkshop((prev) => ({
    //         ...prev,
    //         [name]: value,
    //     }));
    // };

    const handleChange = (e) => {
        setNewWorkshop({ ...newWorkshop, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        const isEditing = Boolean(newWorkshop.id);
        const url = isEditing
            ? "https://devapi.bykit.in/api/admin/workshop/update??type=live"
            : "https://devapi.bykit.in/api/admin/workshop/add??type=live";

        const workshopData = {
            id: isEditing ? newWorkshop.id : undefined, // Include ID only if updating
            workshop_name: newWorkshop.workshop_name,
            name: newWorkshop.name,
            email: newWorkshop.email,
            password: newWorkshop.password,
            phone: newWorkshop.contactPhone,
            owner_name: newWorkshop.ownerName,
            owner_phone: newWorkshop.ownerPhone,
            address: newWorkshop.address,
            latitude: newWorkshop.latitude,
            longitude: newWorkshop.longitude,
            area: newWorkshop.area,
            pincode: newWorkshop.pincode,
        };

        console.log("Workshop Data:", workshopData);

        try {
            const response = await axios.post(
                url,
                workshopData,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Workshop Response:", response);

            if (response.data.status === "RC200") {
                toast.success(isEditing ? "Workshop details updated sucessfully!" : "Workshop added successfully!");
                // setWorkshops((prev) =>
                //     isEditing
                //         ? prev.map((w) => (w.id === newWorkshop.id ? { ...newWorkshop } : w)) 
                //         : [...prev, newWorkshop] // Add new workshop
                // );

                setNewWorkshop({
                    date: new Date().toISOString().split("T")[0],
                    workshop_name: "",
                    address: "",
                    latitude: "",
                    longitude: "",
                    email: "",
                    password: "",
                    ownerName: "",
                    ownerPhone: "",
                    name: "",
                    contactPhone: "",
                    area: "",
                    pincode: "",
                    status: "Active",
                });
                refreshManagers();
                setShowForm(false);
            } else {
                toast.error(response.data?.message || "Failed to process workshop. Please try again.");
            }
        } catch (error) {
            console.error("Error processing workshop:", error);
            toast.error("An error occurred. Please try again.");
        }
    };




    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);


    return (
        <div>
            <ToastContainer></ToastContainer>
            <div className="d-flex align-items-center gap-3">
                <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                </svg>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Manage Workshop</p>

                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                </svg>

                <p className="m-0">Add Workshop</p>


            </div>
            <div className="managebrand_box mt-3" data-aos="fade-up">

                <h4 className='dashboard_head py-4 ps-4 m-0'>Edit Workshop</h4>
                <hr className='p-0 m-0'></hr>
                <form onSubmit={handleSubmit} className="p-4">
                    <div className="row">
                        {/* Workshop Details */}
                        <div className="col-lg-3 col-md-6 mb-3">
                            <label style={{ color: '#475569' }} className="mb-2">Workshop Name</label>
                            <input
                                type="text"
                                name="workshop_name"
                                value={newWorkshop.workshop_name}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 mb-3">
                            <label style={{ color: '#475569' }} className="mb-2">Workshop Address</label>
                            <input
                                type="text"
                                name="address"
                                value={newWorkshop.address}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 mb-3">
                            <label style={{ color: '#475569' }} className="mb-2">Workshop Latitude</label>
                            <input
                                type="text"
                                name="latitude"
                                value={newWorkshop.latitude}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 mb-3">
                            <label style={{ color: '#475569' }} className="mb-2">Workshop Longitude</label>
                            <input
                                type="text"
                                name="longitude"
                                value={newWorkshop.longitude}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>

                        {/* Login Email */}
                        <div className="col-lg-3 col-md-6 mb-3">
                            <label style={{ color: '#475569' }} className="mb-2">Login Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={newWorkshop.email}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        {!selectedWorkshop.id && (
                            <div className="col-lg-3 col-md-6 mb-3">
                                <label style={{ color: '#475569' }} className="mb-2">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={newWorkshop.password}
                                    onChange={handleChange}
                                    required
                                    className="form-control"
                                />
                            </div>
                        )}

                    </div>
                    <div className="row">
                        <h5 style={{ fontSize: '16px', fontWeight: '600' }} className="my-2">Owner Details</h5>
                        <hr></hr>
                        {/* Owner Details */}
                        <div className="col-lg-3 col-md-6 mb-2 mt-3">
                            <label style={{ color: '#475569' }} className="mb-2">Owner Name</label>
                            <input
                                type="text"
                                name="ownerName"
                                value={newWorkshop.ownerName}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 mb-2 mt-3">
                            <label style={{ color: '#475569' }} className="mb-2">Owner Phone Number</label>
                            <input
                                type="text"
                                name="ownerPhone"
                                value={newWorkshop.ownerPhone}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <h5 style={{ fontSize: '16px', fontWeight: '600' }} className="my-2">Contact Person Details</h5>
                        <hr></hr>
                        {/* Contact Person Details */}
                        <div className="col-lg-3 col-md-6 mb-2 mt-3">
                            <label style={{ color: '#475569' }} className="mb-2">Contact Person Name</label>
                            <input
                                type="text"
                                name="name"
                                value={newWorkshop.name}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-md-6 mb-2 mt-3">
                            <label style={{ color: '#475569' }} className="mb-2">Contact Phone Number</label>
                            <input
                                type="text"
                                name="contactPhone"
                                value={newWorkshop.contactPhone}
                                onChange={handleChange}
                                required
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                className="iconify iconify--ic"
                                width="1em"
                                height="1em"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="currentColor"
                                    d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                                ></path>
                            </svg>
                            <span>Submit</span>
                        </button>
                    </div>



                </form>
            </div>

        </div>
    );
}

export default AddWorkshop;
